import { ref } from 'vue';

const defaultWebsiteName = 'Lush Groom';

export function readWebsiteNameFromStorage() {
  let websiteName = localStorage.getItem('website_name') || defaultWebsiteName;
  try {
    const storedWebsite = JSON.parse(localStorage.getItem('selected_website') || 'null');
    if (storedWebsite?.name) websiteName = storedWebsite.name;
  } catch {
    // ignore
  }
  return websiteName;
}

export const currentWebsiteName = ref(readWebsiteNameFromStorage());

export function setCurrentWebsiteName(name) {
  if (name) currentWebsiteName.value = name;
}
